import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBox, MessageBoxVariant } from "@jti/ui";
import styles from "../BillingAddress.module.scss";
export const BillingErrorMessageBox = ({ children }) => {
    return (_jsx(MessageBox, { className: styles.messageBox, variant: MessageBoxVariant.warning, "data-testid": "message-box", isCompact: true, isVisible: true, children: children }));
};
//# sourceMappingURL=BillingErrorMessageBox.js.map